export class Data {
   id: number;
   name: string;
   content: any;
}
